import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import { SlabCreamContainer } from 'src/elements/geometry/slab.cream.styles';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { Benefit, BenefitsContainer, BenefitsTitle, BenefitText } from './benefits.styles';

interface BenefitsProps {
  title: string;
  subtitle: string;
  items: {
    name: string;
    description: string;
    image: IGatsbyImageData
  }[]
}

const Benefits = ({ title, subtitle, items }: BenefitsProps): JSX.Element => {
  return (
    <SlabCreamContainer>
      <BenefitsContainer>
        <BenefitsTitle>
          <FadeInAnimationWrapper>
            <Heading
              text={title}
              size="2.5em"
              sizeMd="1.5em"
              align="center"
            />
          </FadeInAnimationWrapper>
          <FadeInAnimationWrapper>
            <Paragraph
              text={subtitle}
              size="1.25em"
              weight="light"
              align="center"
            />
          </FadeInAnimationWrapper>
        </BenefitsTitle>
        {
          items.map((benefit, index) => (
            <FadeInAnimationWrapper key={index} style={{ display: 'grid', justifySelf: 'center' }}>
              <Benefit>
                <Image childImageSharp={benefit.image} alt={benefit.name} />
                <BenefitText>
                  <Heading
                    text={benefit.name}
                    size="1.25em"
                    weight="normal"
                  />
                  <Paragraph
                    text={benefit.description}
                    size="1.125em"
                    align="left"
                    weight="light"
                  />
                </BenefitText>
              </Benefit>
            </FadeInAnimationWrapper>
          ))
        }
      </BenefitsContainer>
    </SlabCreamContainer>
  )
}

export default Benefits;
